/* eslint no-plusplus:0, no-bitwise:0, no-multi-assign:0 */
// taken from EB_Common
// encode64 helper function to encode data to be submitted
import { navigate } from '@reach/router';

export const encode64 = code => {
  const keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
  const input = escape(code);
  let output = '';
  let chr1 = '';
  let chr2 = '';
  let chr3 = '';
  let enc1 = '';
  let enc2 = '';
  let enc3 = '';
  let enc4 = '';
  let i = 0;
  do {
    chr1 = input.charCodeAt(i++);
    chr2 = input.charCodeAt(i++);
    chr3 = input.charCodeAt(i++);
    enc1 = chr1 >> 2;
    enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
    enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
    enc4 = chr3 & 63;
    if (Number.isNaN(chr2)) {
      enc3 = enc4 = 64;
    } else if (Number.isNaN(chr3)) {
      enc4 = 64;
    }
    output =
      output +
      keyStr.charAt(enc1) +
      keyStr.charAt(enc2) +
      keyStr.charAt(enc3) +
      keyStr.charAt(enc4);
    chr1 = '';
    chr2 = '';
    chr3 = '';
    enc1 = '';
    enc2 = '';
    enc3 = '';
    enc4 = '';
  } while (i < input.length);
  return output;
};

export const getUrlParams = (paramStr) => {
  const params = {};
  const queryStr = paramStr.substring(1);
  const pairs = queryStr.split('&');
  pairs.forEach((item) => {
    const pos = item.indexOf('=');
    if (pos !== -1) {
      const key = item.substring(0, pos);
      const value = item.substring(pos + 1);
      params[key] = value;
    }
  });
  return params;
};

export const formatFormData = formParams =>
  Object.keys(formParams)
    .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(formParams[k])}`)
    .join('&');

export const getParamFromNonIe = key => {
  const url = new URL(window.location.href);
  return url.searchParams.get(key);
};

export const getParam = paramName => {
  paramName = paramName.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  const regex = new RegExp(`[\\?&]${paramName}=([^&#]*)`);
  const results = regex.exec(window.location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

export const goNextPage = (param) => {
  const {
    pageUri,
    showAddress,
    showCustomfield,
    showAlertSubscription,
    showGroupSubscription,
    showIncidentSub,
    routeToHome,
    contactId,
    isSavingSucceed,
    savedModule
  } = param;
  const goReviewPage = () => { navigate('review'); };
  if (location.href.includes(pageUri)) {
    goReviewPage();
    return true;
  }
  if (showAddress) {
    navigate('./mylocation');
  } else if (showAlertSubscription || showGroupSubscription || showIncidentSub) {
    navigate('./subscriptions');
  } else if (showCustomfield) {
    navigate('./additionalInformation');
  } else if (routeToHome) {
    if (isSavingSucceed) {
      navigate('./home', {
        state: {
          messageTitle: savedModule,
          isSavingSucceed: isSavingSucceed
        }
      });
    } else {
      navigate('./home');
    }
  } else {
    navigate('./review');
  }
  return true;
};
// set lat & lng empty
export const clearPosition = (param) => {
  const {
    setFieldValue,
    name,
    value
  } = param;
  setFieldValue(name, value, false);
  setFieldValue('lat', '', false);
  setFieldValue('lon', '', false);
};

export const isEditPage = (pageUri) => {
  if (location.href.includes(pageUri)) {
    return true;
  }
  return false;
};

export const timeToDayhhmmss = (seconds) => {
  if (seconds == null || seconds < 0) return null;
  let sec = seconds;
  const day = Math.floor(sec / 3600 / 24);
  sec = parseInt(sec, 10) - 3600 * day * 24;
  const hh = Math.floor(parseInt(sec / 3600, 10));
  sec = parseInt(seconds, 10) - hh * 3600;
  const mm = Math.floor((sec / 60));
  const ss = parseInt(sec, 10) - mm * 60;
  return `${day}:${hh}:${mm}:${ss}`;
};

export const throttle = (fn, delay) => {
  let timer;
  return function () {
    const context = this;
    const args = arguments;
    if (!timer) {
      timer = setTimeout(() => {
        clearTimeout(timer);
        return fn.apply(context, args);
      }, delay);
    }
  };
};
/**
 * Formats a date timestamp to a localized string based on browser locale
 * @param {string|number} timestamp - The timestamp to format
 * @param {Object} options - Format options to override defaults
 * @returns {string} - Formatted date string
 */
export const formatLocalDate = (timestamp, options = {}) => {
  if (!timestamp) return '';

  const date = new Date(timestamp);
  const locale = navigator.language || navigator.userLanguage || 'en-US';

  const defaultOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZoneName: 'short'
  };

  const formatOptions = { ...defaultOptions, ...options };

  return date.toLocaleString(locale, formatOptions);
};